import fetch from '../config/fetch'

/**微信appid*/
export const APPID = "wx844697a27148c8ff";

/**获取景区banner图*/
export const getScenicBanner = params => fetch('rest/scenic/banner', params, 'POST');

/**获取景区基本信息*/
export const getScenicInfo = params => fetch('rest/scenic/scenic', params, 'POST');

/**获取景区近期日程*/
export const getScenicCalendar = params => fetch('rest/scenic/calendar', params, 'POST');

/**获取指定日期的产品*/
export const getScenicProduct = params => fetch('rest/scenic/product', params, 'POST');

/**获取景区关联讲解员*/
export const getScenicGuide = params => fetch('rest/scenic/guide', params, 'POST');

/**获取讲解员详情*/
export const getScenicGuideDetail = params => fetch('rest/scenic/guideDetail', params, 'POST');

/**获取景区评论*/
export const getScenicComments = params => fetch('rest/scenic/comments', params, 'POST');

/**更换规格计算结算价格(预约/发起拼团)*/
export const getPayTypePrice = params => fetch('rest/pay/typePrice', params, 'POST');

/**获取订单预生成信息(预约/发起拼团)*/
export const getPayPreOrder = params => fetch('rest/pay/preOrder', params, 'POST');

/**获取去参团预生成信息(去参团)*/
export const getPayPreCanOrder = params => fetch('rest/pay/preCanOrder', params, 'POST');

/**用户获取手机验证码*/
export const getPhoneCode = params => fetch('rest/user/getPhoneCode', params, 'POST');

/**用户获取订单列表*/
export const getUserOrderList = params => fetch('rest/user/orderList', params, 'POST');

/**用户获取订单详情*/
export const getUserOrderDetail = params => fetch('rest/user/orderDetail', params, 'POST');

/**用户取消支付*/
export const getPayCancel = params => fetch('rest/pay/cancel', params, 'POST');

/**用户评价订单*/
export const getUserComment = params => fetch('rest/user/comment', params, 'POST');

/**预评价订单信息*/
export const getUserPreComment = params => fetch('rest/user/preComment', params, 'POST');

/**导游打赏列表*/
export const getUserDSList = params => fetch('rest/user/ds/list', params, 'POST');

/**用户预退款*/
export const userPreRefund = params => fetch('rest/user/preRefund', params, 'POST');

/**用户退款*/
export const userRefund = params => fetch('rest/user/refund', params, 'POST');

/**被邀请查看订单详情*/
export const pinOrderDetail = params => fetch('rest/user/pinOrderDetail', params, 'POST');

/**获取景区线路详情*/
export const getScenicRotes = params => fetch('rest/scenic/rotes', params, 'POST');

/**获取可签到订单列表*/
export const userSignList = params => fetch('rest/user/signList', params, 'POST');

/**用户签到*/
export const userSign = params => fetch('rest/user/sign', params, 'POST');

/**获取封面数据*/
export const getScenicCover = params => fetch('rest/scenic/cover', params, 'POST');

/**判断用户是否关注公众号*/
export const getScenicKeySubscribe = params => fetch('rest/user/scenicKeySubscribe', params, 'POST');

/**按照线路id获取线路*/
export const getScenicRote = params => fetch('rest/scenic/rote', params, 'POST');

/**提交订单发票信息*/
export const upPiao = params => fetch('rest/tool/uppiao', params, 'POST');
/**编辑发票历史编辑信息获取*/
export const getPiao = params => fetch('rest/tool/getpiao', params, 'POST');
/**查看开票详情*/
export const piaoDesc = params => fetch('rest/tool/piao', params, 'POST');
/**发票历史编辑信息获取*/
export const getPiao2 = params => fetch('rest/tool/getpiao2', params, 'POST');



//团队预约
/**团队预约获取日期*/
export const getTeamDate = params => fetch('rest/team/getDate', params, 'POST');
/**根据日期获取余票*/
export const getDatePeople = params => fetch('rest/team/datePeople', params, 'POST');
/**提交团队预约信息*/
export const getTeamReport = params => fetch('rest/team/report', params, 'POST');
/**用户获取我的团队预约列表*/
export const getTeamList = params => fetch('rest/team/list', params, 'POST');
/**获取团队预约详情*/
export const getTeamDetail = params => fetch('rest/team/detail', params, 'POST');
/**营业执照识别*/
export const getYyzzocr = params => fetch('rest/team/yyzzocr', params, 'POST');
/**取消预约*/
export const getCancel = params => fetch('rest/team/cancal', params, 'POST');
/**今日是否开放*/
export const getToday = params => fetch('rest/user/today', params, 'POST')










// WEBPACK FOOTER //
// ./src/service/getData.js